/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { orgUnitGuestSchema } from "./orgUnitGuestSchema.ts";

export const orgOrgUnitListQueryOrganizationSchema = z.uuid().optional();

export const orgOrgUnitListStatus200Schema = z.array(orgUnitGuestSchema);

export const orgOrgUnitListResponseSchema = orgOrgUnitListStatus200Schema;
